import { render } from "./MigrationV5.vue?vue&type=template&id=87427440&scoped=true"
import script from "./MigrationV5.vue?vue&type=script&lang=ts"
export * from "./MigrationV5.vue?vue&type=script&lang=ts"

import "./MigrationV5.vue?vue&type=style&index=0&id=87427440&lang=scss&scoped=true"
import "./MigrationV5.vue?vue&type=style&index=1&id=87427440&lang=scss"
script.render = render
script.__scopeId = "data-v-87427440"

export default script